import Hero from '../components/Hero';
import Features from '../components/Features';
import Section from '../components/Section';
import BetaSignup from '../components/BetaSignup';
import Footer from '../components/Footer';
import homeData from '../data/pages/home.json';

export default function HomePage() {
  // Validate data structure
  if (!homeData || !homeData.hero || !homeData.sections) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Configuration Error
          </h1>
          <p className="text-gray-600">
            Unable to load page data. Please contact support.
          </p>
        </div>
      </div>
    );
  }

  const { hero, sections } = homeData;

  return (
    <div className="min-h-screen bg-white">
      <Hero {...hero} />

      {sections.map((section) => {
        if (section.type === 'feature-grid' && section.features) {
          return <Features key={section.id} heading={section.heading} features={section.features} />;
        }

        if (section.type === 'cta' && section.content && section.cta) {
          return <BetaSignup key={section.id} heading={section.heading} content={section.content} cta={section.cta} />;
        }

        return <Section key={section.id} {...section} />;
      })}

      <Footer />
    </div>
  );
}
